import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SKIP_AUTH_ERROR_REDIRECT } from './http-context';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem('access_token');
    const skipRedirect = req.context.get(SKIP_AUTH_ERROR_REDIRECT);

    const authReq = token
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

    return next.handle(authReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (skipRedirect) {
          return throwError(() => err);
        }

        const isAuthRoute =
          req.url.includes('/auth/login') ||
          req.url.includes('/auth/logout') ||
          req.url.includes('/auth/forgot-password') ||
          req.url.includes('/auth/reset-password');

        if (err.status === 401 && !isAuthRoute) {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('chipo_user');

          const returnUrl = this.router.url;
          void this.router.navigate(['/login'], {
            queryParams: returnUrl && returnUrl !== '/login' ? { returnUrl } : undefined,
          });
        }

        if (err.status === 403 && !isAuthRoute) {
          void this.router.navigate(['/forbidden']);
        }

        return throwError(() => err);
      })
    );
  }
}
